import { inject, Injectable } from '@angular/core';

import {
  ClientInfo,
  DianInfo,
  EmissionInfo,
  EmitterInfo,
  InvoiceItem,
  Totals,
} from '@shared-models';

import { GenerateDianContentPdfService } from 'src/app/@pages/details/generate-dian-content-pdf.service';

@Injectable({
  providedIn: 'root',
})
export class PdfElectronicContentService {
  private generateDianContentPdfService = inject(GenerateDianContentPdfService);

  buildContent(
    observations: string,
    emitterInfo: EmitterInfo,
    dian: DianInfo,
    client: ClientInfo,
    emission: EmissionInfo,
    items: InvoiceItem[],
    totals: Totals,
    documentType: string,
  ) {
    return [
      emitterInfo,
      this.generateDianContentPdfService.createCufeInfo(dian),
      this.generateDianContentPdfService.createClientAndEmission(
        client,
        emission,
        documentType,
      ),
      this.generateDianContentPdfService.createDetailTable(items),
      {
        columns: [
          {
            width: '60%',
            stack: [
              { text: 'Observaciones:', style: 'dianSectionHeader' },
              {
                text: observations,
                style: 'dianObs',
              },
            ],
            alignment: 'left',
            margin: [0, 12, 0, 0],
          },
          {
            width: '40%',
            stack: [this.generateDianContentPdfService.createTotals(totals)],
            alignment: 'right',
          },
        ],
        margin: [0, 0, 0, 8],
      },
    ];
  }
}
